import React from "react";
import { DateInput } from "@/components/FormInputs";
import { useTranslation } from "react-i18next";
import { X } from "lucide-react";

export const DATE_FORMAT = "MMM d, yyyy";

export const DateInputBar = ({
  date,
  compareDate,
  onDateChange,
  onCompareDateChange,
  allowCompare,
}: {
  date: Date;
  compareDate?: Date;
  onDateChange?: (date: Date) => void;
  onCompareDateChange?: (date: Date | undefined) => void;
  allowCompare: boolean;
}) => {
  const { t } = useTranslation();
  return (
    <div className="flex items-center gap-x-4">
      <DateInput
        value={date}
        buttonClassName="rounded-full has-[>svg]:px-6"
        onApply={onDateChange}
        dateFormat={DATE_FORMAT}
        widthFull={false}
        disabled={{
          after: new Date(),
        }}
        showApplyButton={true}
      />
      {allowCompare && (
        <>
          <div className="text-muted-foreground">
            {t("zeemeeFunnel.datePickers.compareTo")}
          </div>
          <DateInput
            value={compareDate}
            buttonClassName="rounded-full has-[>svg]:px-6"
            onApply={onCompareDateChange}
            dateFormat={DATE_FORMAT}
            widthFull={false}
            disabled={{
              after: new Date(),
            }}
            showApplyButton={true}
          />
          {compareDate && (
            <button
              onClick={() =>
                onCompareDateChange && onCompareDateChange(undefined)
              }
              className="flex items-center gap-x-2 pt-[2px] text-xs"
            >
              {t("zeemeeFunnel.datePickers.removeComparison")}
              <X className="opacity-40" size={14} strokeWidth={3} />
            </button>
          )}
        </>
      )}
    </div>
  );
};
